import React from 'react'
import './index.css'

const Footer = () =>
  <footer className='app-footer'>
    <a href='https://icons8.com'>Icon pack by Icons8</a>
  </footer>

export default Footer



// WEBPACK FOOTER //
// ./src/modules/Footer/index.jsx